import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ScfHoldPointDashboardRow } from './scf-hold-point-dashboard.models';

@Injectable({ providedIn: 'root' })
export class ScfHoldPointDashboardService {
  private readonly api = `${environment.urls.baseApiUrl}/SCFMasterV2/HoldPointDashboard`;

  constructor(private readonly http: HttpClient) { }

  /** Loads open SCFs and their persisted hold-point signature progress. */
  getDashboard(): Observable<ScfHoldPointDashboardRow[]> {
    return this.http.get<ScfHoldPointDashboardRow[]>(this.api);
  }
}
